import { Component, OnInit, Input } from '@angular/core';
import { AuthInput } from '../model/auth-input-model';
import { FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'lib-form-auth',
  templateUrl: './form-auth.component.html',
  styleUrls: ['./form-auth.component.scss']
})
export class FormAuthComponent implements OnInit {
  authForm: FormGroup;
  @Input() items: AuthInput[];
  @Input() formClass: string;
  @Input() submitHandler(form: FormGroup): void {}

  ngOnInit() {
    this.authForm = new FormGroup({
      ...this.getPtoperties(),
    });
  }

  getPtoperties() {
    const properties = this.items.reduce((obj, item) => {
      obj[item.name] = new FormControl('', [
        Validators.minLength(item.minlength),
        this.findInvalidCharacters.bind(this),
        item.required ? Validators.required : null,
      ]);

      return obj;
    }, {});

    return properties;
  }

  findInvalidCharacters(control: FormControl) {
    if (control.value.search(/[^\w@_-]/g) !== -1) {
      return { isInvalidSymbols: true };
    }

    return null;
  }

  onSubmit() {
   this.submitHandler(this.authForm);
  }
}
